/* eslint-disable */
import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JoditEditor from "jodit-react";
import Select from "react-select";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import {
  deleteData,
  getData,
  postData,
  putData,
  uploadSingleFile,
  uploadMultipleFile,
} from "utils/Gateway";

import { getAllCategories } from "helper/CategoryHelper/CategoryHelper";
import { ecosystemSlug, reactSelectStyle } from "Config/Config";
import FileUploadField from "components/Common/FileUploadField/FileUploadField";
import { getFileIcon } from "helper/Common/CommonHelper";

const SaveFaqPopup = ({
  selectedFaqId = null,
  setSelectedFaqId = () => {},
  afterPopupClose = () => {},
}) => {
  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const { t, i18n } = useTranslation();

  const spinCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  const [categoryList, setCategoryList] = useState([]);

  const [faqData, setFaqData] = useState("");
  const [title, settitle] = useState("");
  const [details, setdetails] = useState("");

  const [categoryValue, setCategoryValues] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  // initial state for uploaded multiple files
  const [media, setMedia] = useState([]);

  //initial state for uploaded image id
  const [fileIds, setFileIds] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const [isAsking, setIsAsking] = useState(false);

  const [isSaving, setisSaving] = useState(false);

  const [showContext, setShowContext] = useState(false);

  const [errors, setErrors] = useState({});

  const editor = useRef(null);

  const detailsEditorCustomConfig = {
    readonly: false,
    toolbarSticky: false,
    placeholder: "",
    height: "250",
    statusbar: false,
    uploader: {
      insertImageAsBase64URI: false,
    },
    events: {
      afterPaste: async (event) => {
        // take the saved clipboard data
        const clipboardData = event.clipboardData || window.clipboardData;
        const items = clipboardData.items;

        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const file = items[i].getAsFile();

            // Rename the file using a timestamp
            const timestamp = Date.now();
            const fileExtension = file.type.split("/")[1]; // Get the file extension (e.g., png, jpeg)
            const newFileName = `image-${timestamp}.${fileExtension}`;

            const renamedFile = new File([file], newFileName, {
              type: file.type,
            });

            try {
              // upload the file data in server
              const requestURL =
                url.API_BASE_URL +
                url.API_SINGLE_FILE_UPLOAD +
                `?token=${token}`;

              const response = await uploadSingleFile(requestURL, renamedFile);

              if (response.status) {
                const imageUrl = url.SERVER_URL + response.data.path;
                // console.log("imageUrl", imageUrl);

                // Replace blob URL with the server URL
                const editorInstance = editor.current;

                if (editorInstance) {
                  const content = editorInstance.value;
                  const regex = /<img[^>]+src="data:image\/[^">]+"/g;
                  const newContent = content.replace(regex, (match) => {
                    const base64DataMatch = match.match(/src="([^"]+)"/);
                    if (
                      base64DataMatch &&
                      base64DataMatch[1].startsWith("data:image/")
                    ) {
                      return match.replace(base64DataMatch[1], imageUrl);
                    }
                    return match;
                  });

                  // add in editor content
                  editorInstance.value = newContent;

                  // add in state content
                  setdetails(newContent);
                }
              }
            } catch (error) {
              console.error("Image upload failed:", error);
            }
          }
        }
      },
    },
    defaultActionOnPaste: "insert_as_html",
    defaultLineHeight: 1.5,
    enter: "div",
    sizeLG: 900,
    sizeMD: 700,
    sizeSM: 400,
    toolbarAdaptive: false,
    disablePlugins: [
      "image",
      "video",
      "about",
      "classSpan",
      "file",
      "speechRecognize",
      "copyformat",
      "spellcheck",
      "link",
      "add-new-line",
    ],
  };

  const detailsEditorConfig = useMemo(() => detailsEditorCustomConfig, []);

  //function for get all category
  const fetchAllCategories = async () => {
    try {
      const parentSlug = "FAQ";
      const response = await getAllCategories(ecosystemSlug, parentSlug);

      setCategoryList(response);
    } catch (error) {
      console.log(error.message);
    }
  };

  //validation function
  const validationHandler = () => {
    const newErrors = {};
    if (!title.trim()) {
      newErrors.title = t("Please enter the question for the FAQ.");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // function for multiple file upload
  const multipleFileUploadHandler = async (targetFiles) => {
    let filesLength = targetFiles.length;

    let proceed = false;

    if (filesLength > 0) {
      for (let i = 0; i < filesLength; i++) {
        let f = targetFiles[i];

        if (f.size <= 12500000) {
          proceed = true;
        } else {
          proceed = false;
        }
      }

      if (proceed) {
        try {
          setIsUploading(true);
          let requestURL =
            url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

          const response = await uploadMultipleFile(requestURL, targetFiles);

          console.log(response);

          setIsUploading(false);

          resetFile();

          if (response.status) {
            const uploadedFileValues = response.data.map(
              ({ name, path, _id, ...other }) => ({
                name,
                path: url.SERVER_URL + path,
                _id,
              })
            );

            const fileIds = response.data.map(({ _id, ...other }) => ({
              _id,
            }));

            //check old file exist or not if exist then new file will concat with old file
            if (media.length === 0) {
              setMedia(uploadedFileValues);
              setFileIds(fileIds);
            } else {
              setMedia((prevMedia) => [...prevMedia, ...uploadedFileValues]);
              setFileIds((prevFileids) => [...prevFileids, ...fileIds]);
            }
          }
        } catch (error) {
          console.error("Image upload failed:", error);
        }
      }
    } else {
      return;
    }
  };

  // function for clear file value
  const resetFile = () => {
    const file = document.getElementById("faqFile");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  const deletFileHanlder = (index) => {
    const updatedIds = [...fileIds];
    const updatedmedia = [...media];
    const fileMediaindex = updatedIds.indexOf(index);
    const fileIdIndex = updatedmedia.indexOf(index);
    updatedIds.splice(fileIdIndex, 1);
    updatedmedia.splice(fileMediaindex, 1);

    setFileIds(updatedIds);
    setMedia(updatedmedia);
  };

  //function for select categories
  const categorySelectionHandler = (val) => {
    setCategoryValues(val);
    const categoryArr = val.map((item) => item.value);
    setSelectedCategories(categoryArr);
  };

  //get faq details
  const getFaqDetails = async () => {
    setFaqData("");

    try {
      let requestURL =
        url.API_BASE_URL +
        url.API_GET_FAQ_DETAILS +
        `/${selectedFaqId}?token=${token}`;

      const response = await getData(requestURL);

      console.log("respnse in get faq details", response);

      if (response.status) {
        const data = response.data;
        setFaqData(data);

        settitle(data.question);
        setdetails(data.answer);

        setFileIds(data.uploadids);
        setMedia(
          data.uploadedfiles.map(({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          }))
        );

        if (data.categoryvalues) {
          categorySelectionHandler(data.categoryvalues);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //get response from ai
  const getResponseFromAI = async () => {
    try {
      setIsAsking(true);

      let apiData = {
        message: title,
        token: "lobees",
      };

      let requestURL =
        url.API_BASE_URL + url.API_GET_RESPONSE_FROM_AI + `?token=${token}`;

      const response = await postData(requestURL, apiData);

      console.log(response);

      setIsAsking(false);

      if (response.status) {
        setdetails(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //save faq function
  const saveFaqHandler = async (e) => {
    if (!validationHandler()) {
      return;
    }
    try {
      setisSaving(true);

      let apiData = {
        question: title,
        answer: details,
        answeredby: userInfo._id,
        categoryids: selectedCategories,
        uploads: fileIds,
      };

      let requestURL = url.API_BASE_URL;

      let response = {};

      if (selectedFaqId) {
        requestURL += url.API_UPDATE_FAQ + `/${selectedFaqId}?token=${token}`;

        response = await putData(requestURL, apiData);
      } else {
        requestURL += url.API_CREATE_FAQ + `?token=${token}`;

        response = await postData(requestURL, apiData);
      }

      setisSaving(false);

      console.log(response);

      if (response.status) {
        // close the modal
        let offCanvasPopup = document.querySelector("#saveFaqOffcanvas");
        let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
        offCanvas.hide();

        resetHandler();
        afterPopupClose();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //reset function
  const resetHandler = () => {
    settitle("");
    setdetails("");
    setCategoryValues(null);
    setSelectedCategories([]);
    setMedia([]);
    setFileIds([]);
    setSelectedFaqId(null);
    setFaqData("");
    setErrors({});
  };

  useEffect(() => {
    fetchAllCategories();
  }, []);

  useEffect(() => {
    if (selectedFaqId) {
      getFaqDetails();
    }
  }, [selectedFaqId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="saveFaqOffcanvas"
      aria-labelledby="saveFaqOffcanvasLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              help
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="saveFaqOffcanvasLabel"
            >
              {t("Respond to FAQ")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Manage and respond to frequently asked questions")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form
            onSubmit={(e) => e.preventDefault()}
            className="d-flex flex-column"
          >
            <div className="field-container flex-fill">
              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="question"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Question")}
                </label>
                <input
                  type="text"
                  id="question"
                  className={`form-control fs-sm shadow-none ${
                    errors.title ? "is-invalid" : "border border-gray-300"
                  }`}
                  placeholder={t("Enter Question")}
                  value={title}
                  onChange={(e) => {
                    settitle(e.target.value);
                    if (errors.title) {
                      setErrors((prev) => ({ ...prev, title: "" }));
                    }
                  }}
                />
                {errors.title && (
                  <div className="invalid-feedback d-block">{errors.title}</div>
                )}
              </div>

              <div className="form-group mb-4 p-3 pb-0 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="answer"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Answer")}
                </label>
                <JoditEditor
                  ref={editor}
                  value={details}
                  config={detailsEditorConfig}
                  onBlur={(newContent) => {
                    // console.log("New content in on blur----->", newContent);
                    setdetails(newContent);
                  }}
                  onChange={(newContent, event) => {
                    // setdetails(newContent);
                  }}
                />
                <div className="d-flex justify-content-end my-2">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
                    onClick={getResponseFromAI}
                    disabled={isAsking}
                  >
                    {isAsking ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-1"
                          role="status"
                        ></span>
                        <span>Generating...</span>{" "}
                      </>
                    ) : (
                      <>
                        <span
                          className="material-symbols-outlined"
                          style={{ fontSize: "16px" }}
                        >
                          auto_awesome
                        </span>
                        <span>Suggest by AI</span>{" "}
                      </>
                    )}
                  </button>
                </div>
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="question"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t("Category")}
                </label>

                <Select
                  isMulti
                  styles={reactSelectStyle("3px", "6px", true, false)}
                  placeholder={t("Select Category")}
                  options={categoryList}
                  value={categoryValue}
                  onChange={categorySelectionHandler}
                />
              </div>

              <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                <label
                  htmlFor="question"
                  className="d-block fs-sm fw-semibold mb-2 text-dark"
                >
                  {t(" Attach File")}{" "}
                  <i>
                    Max 20 MB /
                    (jpg,jpeg,png,gif,doc,docx,pdf,xlsx,xls,mp4,webm,ogg )
                  </i>
                </label>
                <FileUploadField
                  label={t("Upload Documents")}
                  accept="doc mp4 pdf"
                  onUpload={multipleFileUploadHandler}
                  files={media}
                  onRemove={deletFileHanlder}
                  loading={isUploading}
                  multiple
                  fileType="document"
                />
              </div>

              {/* show context from faqData.context and referencedocument from faqData.referencedocument */}
              {faqData.context && faqData.referencedocument && (
                <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
                  {faqData && faqData.context && (
                    <div className="mt-3">
                      <h6 className="fw-bold text-dark">{t("Context")}</h6>
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        style={{ fontSize: "0.95em" }}
                        onClick={() => setShowContext((prev) => !prev)}
                      >
                        {showContext ? "Hide Context" : "Show Context"}
                      </button>
                      {showContext && (
                        <div className="accordion-body mt-2 bg-white border rounded p-2">
                          <p className="text-muted mb-0">{faqData.context}</p>
                        </div>
                      )}
                    </div>
                  )}

                  {faqData && faqData.referencedocument && (
                    <div className="mt-3">
                      <h6 className="fw-bold text-dark">
                        {t("Reference Document")}
                      </h6>
                      <div
                        className="file d-flex file_gap align-items-center px-3 py-2 border border-gray rounded-3 shadow-sm"
                        style={{ maxWidth: "450px" }}
                      >
                        <span className="material-symbols-outlined text-primary">
                          {getFileIcon(faqData.referencedocument?.name)}
                        </span>
                        <p className="fw-medium text-truncate me-auto mb-0">
                          {faqData.referencedocument?.name}
                        </p>
                        <a
                          href={
                            url.SERVER_URL + faqData.referencedocument?.path
                          }
                          download
                          target="_blank"
                          rel="noopener noreferrer"
                          className="p-2 bg-light rounded-5 border border-gray-300"
                          title="Download"
                        >
                          <span className="d-block material-symbols-outlined icon-md text-gray-600 fw-medium">
                            download
                          </span>
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={saveFaqHandler}
                disabled={isSaving}
                style={{ cursor: isSaving ? "not-allowed" : "pointer" }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Saving...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>{" "}
                    {t("Save Faq")}
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveFaqPopup;
